import { render, staticRenderFns } from "./GestioneCampiDefault.vue?vue&type=template&id=1e8373f3&"
import script from "./GestioneCampiDefault.vue?vue&type=script&lang=js&"
export * from "./GestioneCampiDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports